const crane = new URL('../../icons/crane.png', import.meta.url).href

export default {
  type: 'Crane',
  description: 'Crane',
  icon: crane,
  group: 'SCS',
  model: {
    type: 'Crane',
    left: 100,
    top: 100,
    width: 20,
    height: 20
  }
}
